
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
export default {
  name: "Modifier",
  components: {
    ErrorComponent,
    Alert
  },
  data() {
    return {
      list: [],
      storeList: [],
      modifierOptions: [],
      currentSorting: "",
      modifier: {
        name: ""
      },
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: ""
      }
    };
  },
  methods: {
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.$api
        .getAPI({
          _action: "/modifier/list",
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_modifier_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    gotoModifierEdit(id) {
      router.push("/edit-modifier/" + id);
    },

    deleteModifier(e) {
      if (this.modifier.id) {
        this.$api
          .deleteAPI({
            _action: "/modifier/delete/" + this.modifier.id
          })
          .then(res => {
            this.$refs.deleteModifierAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.modifier.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteModifierAlert.close();
          });
      }
    },
    setObj(id, name) {
      this.modifier.id = id;
      this.$refs.deleteModifierAlert.message = this.$lang.messages.delete_modifier_message;
    },

    addModifier() {
      router.push("/add-modifier");
    }
  },
  mounted() {
    this.getStoreList();
    this.getList(1);
  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-right">
              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;"
              >
                <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                  <option value>{{$lang.messages.all_stores}}</option>
                  <option
                    v-for="store in storeList"
                    :key="store.id"
                    :value="store.id"
                  >{{store.name}}</option>
                </select>
              </div>
              <a
                href="javascript:void(0)"
                @click="addModifier()"
                class="btn btn-primary px-4"
              >+ {{$lang.messages.add_modifiers}}</a>
            </div>

            <div class="card rounded-5">
              <div class="card-body">
                <table class="table table-striped table-style-1 table-responsive">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col" width="80" class="w-xs-25"></th>
                      <th scope="col">{{$lang.messages.name}}</th>
                      <th scope="col">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(modifier,i) in list" :key="modifier.id">
                      <td>{{i + 1}}</td>
                      <td>
                        <i class="fas fa-circle" style="font-size: 35px; color:#F44236"></i>
                      </td>
                      <td>
                        <p class="f-semi-bold mb-0">{{modifier.name}}</p>
                        <p class="font-14 text-grey">
                          <span
                            v-for="(modifierOptions, index) in modifier.modifier_options"
                            :key="modifierOptions.id"
                          >
                            {{modifierOptions.name}}
                            <span
                              v-if="index != (modifier.modifier_options.length - 1)"
                            >,</span>
                          </span>
                        </p>
                      </td>

                      <td>
                        <a
                          href="javascript:void(0)"
                          @click="gotoModifierEdit(modifier.id)"
                          class="text-primary mr-2 font-18"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href="javascript:void(0)"
                          data-toggle="modal"
                          data-target="#delete-modifier-modal"
                          @click="setObj(modifier.id)"
                        >
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                        <!-- &nbsp;&nbsp;
                        <a
                          href="javascript:void(0)"
                          style="cursor: all-scroll"
                        >
                          <i class="mdi mdi-cursor-move ml-2"></i>
                        </a>-->
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert
      @rightButtonEvent="deleteModifier($event)"
      v-bind:title="$lang.messages.delete_modifier"
      ref="deleteModifierAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-modifier-modal"
    />
  </div>
</template>